export default __webpack_public_path__ + "static/media/googleplay.11027f8a.svg";